import axios from "axios";
import { Dispatch } from "redux";
import { ActionTypes } from "./types";
import { API_URL } from "../utils/api";
import { setAxiosToken } from "../utils/AxiosToken";
import { errorToText } from "../utils/functions";
import { UserAccessInterface, UserAccessList } from "../config/userAccess";
import { LanguageEnum } from "../components/SelectService/SelectService";
import { CommunicationChannelItem } from "./services.action";

/**
 * * ****************************** INTERFACES *****************************
 */

export interface UserRoleInterface {
  access: UserAccessInterface[];
  role_id: string;
  role_name: string;
}

export interface BehaviorItemInterface {
  behavior_id: string;
  behavior_name: string;
}

export interface DivisionItem {
  division_id: string;
  division_name: string;
}

export interface TrainingOfferModeItem {
  training_offer_mode_id: string;
  offer_mode: string;
}

export interface BasicInfo {
  division: DivisionItem[];
}

export interface AccessListDetails {
  access_key: UserAccessList;
  access_name: string;
}

export interface SpecializationItemInterface {
  specialization_id: string;
  specialization_name: string;
}

export interface FAQuestionInterface {
  faq_id: string;
  question_kiny: string;
  question_en: string;
  question_fr: string;
  answer_kiny: string;
  answer_en: string;
  answer_fr: string;
}

export interface System {
  side_nav: boolean;
  basic_info: BasicInfo | null;
  access_details: AccessListDetails[] | null;
  error: string;
  success: string;
  language: LanguageEnum;
  FAQs: FAQuestionInterface[] | null;
  communication_channels: CommunicationChannelItem[] | null;
}

//* ********************** ACTION TYPE INTERCACES ********************** */
export interface GetSystemInfoAction {
  type: ActionTypes.GET_SYSTEM_BASIC_INFO;
  payload: BasicInfo;
}

export interface GetAccessListDetailsInfoAction {
  type: ActionTypes.GET_ALL_ACCESS_DETAILS;
  payload: AccessListDetails[];
}

export interface GetFrequentlyAskedQuestionsInfoAction {
  type: ActionTypes.GET_FAQ_ACTION;
  payload: FAQuestionInterface[];
}

export interface SetSystemErrorMessageAction {
  type: ActionTypes.SET_SYSTEM_ERROR_MESSAGE;
  payload: string;
}
export interface SetSystemSuccessMessageAction {
  type: ActionTypes.SET_SYSTEM_SUCCESS_MESSAGE;
  payload: string;
}

export interface ChangeSystemLanguageAction {
  type: ActionTypes.CHANGE_SYSTEM_LANGUAGE;
  payload: LanguageEnum;
}

export interface GetCommunicationChannelsAction {
  type: ActionTypes.GET_COMMUNICATION_CHANNELS;
  payload: CommunicationChannelItem[];
}

/**
 * * ****************************** ACTIONS *****************************
 */
/**
 * @description Register the account to the api
 * @param account
 * @param MsgHandler return the error from the API
 * @returns
 */
export const FC_GetSystemInfo = (callback: (loading: boolean) => void) => {
  return async (dispatch: Dispatch) => {
    callback(true);
    setAxiosToken();
    try {
      const res = await axios.get<BasicInfo>(`${API_URL}/basic/data`);

      console.log({ system_basic_info: res.data });

      dispatch<GetSystemInfoAction>({
        type: ActionTypes.GET_SYSTEM_BASIC_INFO,
        payload: res.data,
      });
      callback(false);
    } catch (error: any) {
      dispatch<SetSystemErrorMessageAction>({
        type: ActionTypes.SET_SYSTEM_ERROR_MESSAGE,
        payload: errorToText(error),
      });
      callback(false);
      console.log("err: ", { ...error });
    }
  };
};

export const FC_GetSystemAccessDetails = (
  callback: (loading: boolean) => void
) => {
  return async (dispatch: Dispatch) => {
    callback(true);
    setAxiosToken();
    try {
      const res = await axios.get<AccessListDetails[]>(`${API_URL}/access`);

      console.log({ access_details: res.data });

      dispatch<GetAccessListDetailsInfoAction>({
        type: ActionTypes.GET_ALL_ACCESS_DETAILS,
        payload: res.data,
      });
      callback(false);
    } catch (error: any) {
      dispatch<SetSystemErrorMessageAction>({
        type: ActionTypes.SET_SYSTEM_ERROR_MESSAGE,
        payload: errorToText(error),
      });
      callback(false);
      console.log("err: ", { ...error });
    }
  };
};

export const FC_SetError = (msg: string) => {
  return async (dispatch: Dispatch) => {
    dispatch<SetSystemErrorMessageAction>({
      type: ActionTypes.SET_SYSTEM_ERROR_MESSAGE,
      payload: msg,
    });
  };
};
export const FC_SetSuccess = (msg: string) => {
  return async (dispatch: Dispatch) => {
    dispatch<SetSystemSuccessMessageAction>({
      type: ActionTypes.SET_SYSTEM_SUCCESS_MESSAGE,
      payload: msg,
    });
  };
};

export const FC_ChangeSystemLanguage = (lang: LanguageEnum) => {
  return async (dispatch: Dispatch) => {
    dispatch<ChangeSystemLanguageAction>({
      type: ActionTypes.CHANGE_SYSTEM_LANGUAGE,
      payload: lang,
    });
  };
};

export const FC_GetFrequentlyAskedQuestions = (
  callback: (loading: boolean) => void
) => {
  return async (dispatch: Dispatch) => {
    callback(true);
    setAxiosToken();
    try {
      const res = await axios.get<FAQuestionInterface[]>(
        `${API_URL}/faqsanswers`
      );

      console.log({ FrequentlyAskedQuestions: res.data });

      dispatch<GetFrequentlyAskedQuestionsInfoAction>({
        type: ActionTypes.GET_FAQ_ACTION,
        payload: res.data,
      });
      callback(false);
    } catch (error: any) {
      dispatch<SetSystemErrorMessageAction>({
        type: ActionTypes.SET_SYSTEM_ERROR_MESSAGE,
        payload: errorToText(error),
      });
      callback(false);
      console.log("err: ", { ...error });
    }
  };
};

export const FC_GetCommunicationChannels = (
  callback: (loading: boolean) => void
) => {
  return async (dispatch: Dispatch) => {
    callback(true);
    setAxiosToken();
    try {
      const res = await axios.get<CommunicationChannelItem[]>(
        `${API_URL}/communications/channel`
      );

      console.log({ CommunicationChannels: res.data });

      dispatch<GetCommunicationChannelsAction>({
        type: ActionTypes.GET_COMMUNICATION_CHANNELS,
        payload: res.data,
      });
      callback(false);
    } catch (error: any) {
      dispatch<SetSystemErrorMessageAction>({
        type: ActionTypes.SET_SYSTEM_ERROR_MESSAGE,
        payload: errorToText(error),
      });
      callback(false);
      console.log("err: ", { ...error });
    }
  };
};
